import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import utils from "../../../utils/validateScanner"

export default {
  name: 'markbulkbagshortage',
  mixins: [utils],
  components: {
    VueElementLoading
  },
  props: [],
  data() {
    return {
      bagNo:'',
      bagNoError:'',
      shortagebaglist:[],
      checkAllbags:false,
      listLoading:false,
      hubName:'',
      EligibleBagCount:0,
      NonEligibleBagCount:0,
      EligibleBag:[],
      bulkBagArr: [],
      BagArr:[],
      checked:[],
      selected:[],
      CenterType:'',
      bagLimit:false,
      bagLimitMsg:'',
      addmodalShowflag:false,
      markshortLoading:false
    }
  },
  computed: {},
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.useremail        = userdetail[0].email;
    this.currenthubid =userdetail[0].HubId[0];
    this.getHubName();
  },
  methods: {
    getHubName() {
      this.input = {
        hubids: [this.currenthubid]
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName;
            this.CenterType =result.data.ResponseData[0].CenterType;
          }
        }, error => {
          console.error(error)
        })
    },

    resetForm() {
      this.bagNoError='',
      this.bagNo='',
      this.EligibleBagCount=0,
      this.NonEligibleBagCount=0;
      this.checkAllbags = false;
      this.shortagebaglist=[];
      this.EligibleBag=[];
      this.bulkBagArr= [];
      this.checked=[];
      this.BagArr=[];
      this.selected=[];
      this.listLoading=false;
      this.bagLimit=false;
      this.bagLimitMsg='';
      this.addmodalShowflag=false;
      this.markshortLoading=false;
      this.$validator.reset();
      this.showHideCodeIconInput();
    },

    checkBag() {
        if (typeof InstallTrigger !== 'undefined' == true) {
            this.checkAllbags = !this.checkAllbags;
        }
        this.BagArr = [];

        let nArr = [...new Set(this.EligibleBag.map(a => a.bagno))];
        if (this.checkAllbags) {
          for (var i = 0; i < this.EligibleBag.length; i++) {
            this.checked[this.EligibleBag[i].bagno]=true;
          }

          this.BagArr   = nArr;
          let arr       = [...this.bulkBagArr, ...this.BagArr];
          this.bulkBagArr = [...new Set(arr)];
        }else{
           for (var i = 0; i < this.EligibleBag.length; i++) {
             this.checked[this.EligibleBag[i].bagno]=false;
           }
           this.bulkBagArr = this.bulkBagArr.filter(val => !nArr.includes(val));
        }
    },

    updateselected(event){
     this.checked[event.target.id] = event.target.checked;

     if(event.target.checked==false){
       this.bulkBagArr = this.bulkBagArr.filter(el => el != event.target.id)

     }else{
       this.bulkBagArr.indexOf(event.target.id) === -1 ? this.bulkBagArr.push(event.target.id):'';
     }
     this.checkAllbags = (this.EligibleBag.length === this.bulkBagArr.length) ? true : false;
	 },


    getBulkBagDetailsByBagnos() {
      this.listLoading=true;
      this.checkAllbags=false;
      this.shortagebaglist=[];
      this.EligibleBag=[];
      this.bulkBagArr= [];
      this.checked=[];
      this.BagArr=[];
      if (this.bagNo == '') {
        this.listLoading=false;
				this.bagNoError = "The Bag No is required."
        return true;
			}
      else {
        this.bagNo = this.bagNo.trim();
        this.bagNoError = '';
      if(/\r?\n|\r/g.test(this.bagNo) == true){
        this.bagNo = this.bagNo.replace(/\r?\n|\r/g,',');
      }
      if(/\s/g.test(this.bagNo) == true || this.bagNo.indexOf(',') > -1){
        this.bagNo = this.bagNo.replace(/\n|"|'| |\t|,\s*$/g,'').split(',').filter(item => item);
      }
      if(Array.isArray(this.bagNo) == true){
        this.bagNo = this.bagNo.join(',');
      }
    let bagArray=[];
 	 bagArray.push(this.bagNo.split(","));
 	 if(bagArray[0].length >50)
 	 {
     this.listLoading = false;
 		 this.bagLimit=true;
 		 this.bagLimitMsg="Please Enter Bags Upto 50"
 		 return false;
 	 }
      this.input = {
        "bagNos": this.bagNo
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'getBulkBagDetailsByBagnos',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            if (result.data.lossCategorization && Object.keys(result.data.lossCategorization).length != 0) {
              this.colorCode = result.data.lossCategorization.colorCode;
              this.colorIcon = result.data.lossCategorization.icon;
            }
            this.shortagebaglist = result.data.ResponseData;
            for (var i = 0; i < this.shortagebaglist.length; i++) {
              if(this.shortagebaglist[i].allowshortage==true){
              this.EligibleBag.push(this.shortagebaglist[i]);
              }
            }
            this.EligibleBagCount=result.data.EligibleBagCount;
            this.NonEligibleBagCount=result.data.NonEligibleBagCount;
            this.$alertify.success(result.data.ReturnMessage)

          } else {
            this.$alertify.error(result.data.ReturnMessage)
            this.shortagebaglist=[]
          }
          this.listLoading= false;
          this.invalidTokenModal = false
        }, error => {
          this.listLoading = false;
          console.error(error);
        })
         }
    },

  addmodalShow(data){
    this.selected=data ? data : [];
    if(data){
      this.bulkBagArr =[];
      this.checked=[];
      this.checkAllbags=false;
    } else if(this.bulkBagArr.length == 0){
      this.$alertify.error("Please select at least one bag");
      return;
    }
    this.addmodalShowflag=true;
  },
  closeStatusModal(){
    this.addmodalShowflag=false;
  },

    markBulkBagShortage() {
    this.markshortLoading = true;
   this.input = {
     currentHubId: this.currenthubid,
     currentHubName: this.hubName,
     reason: "",
     lastModifiedBy: this.useremail,
     parentBagNos:(this.selected && this.selected.bagno)?  this.selected.bagno:this.bulkBagArr.toString(),
     centerType: this.CenterType
   }
    axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + "markBulkBagShortage",
        'data': this.input,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
      .then(result => {
        if (result.data.ResultCode == 100) {
          this.$alert(result.data.ReturnMessage, "", "success");
          this.addmodalShowflag=false;
         this.resetForm();
        } else {
          this.$alert(result.data.ReturnMessage, "", "error");
        }
        this.markshortLoading = false;
      }, error => {
        this.markshortLoading = false;
        console.error(error)
      })
    },

    takeAction(){
      this.markBulkBagShortage();
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/MarkBulkBagShortage/MarkBulkBagShortage.js